/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * STARTED — by whom in by; EVENT — eventType says which; ANSWERED — the first answer to the question; ANSWER_CHANGED — every later one; FINISHED; EXPIRED — the time ran out; INVALIDATED — by whom in by, why in reason; GRADED — an examiner\'s first grade of a question of an exam, GRADE_CHANGED — every later one, by whom in by; RESULT_CLOSED — the screen of the result was closed and the key stopped working. FINISHED of an exam names the examiner in by.
 * @export
 * @enum {string}
 */

export const AttemptTimelineKindDto = {
    Started: 'STARTED',
    Event: 'EVENT',
    Answered: 'ANSWERED',
    AnswerChanged: 'ANSWER_CHANGED',
    Finished: 'FINISHED',
    Expired: 'EXPIRED',
    Invalidated: 'INVALIDATED',
    Graded: 'GRADED',
    GradeChanged: 'GRADE_CHANGED',
    ResultClosed: 'RESULT_CLOSED'
} as const;

export type AttemptTimelineKindDto = typeof AttemptTimelineKindDto[keyof typeof AttemptTimelineKindDto];



